import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Create a single Audio element that we'll reuse
    this.audio = new Audio();
    this.activeButton = null;
  }

  play(event) {
    const button = event.currentTarget;
    const soundPath = button.dataset.soundPath;

    // Remove active state from previous button
    if (this.activeButton) {
      this.activeButton.classList.remove("active");
    }

    // If clicking the same button that's playing, stop it
    if (this.activeButton === button && !this.audio.paused) {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.activeButton = null;
      return;
    }

    // Stop any currently playing sound
    this.audio.pause();
    this.audio.currentTime = 0;

    // Play the new sound
    this.audio.src = soundPath;
    this.audio.play().catch((error) => {
      console.error("Error playing sound:", error);
    });

    // Add active state to current button
    button.classList.add("active");
    this.activeButton = button;

    // When sound finishes, remove active state
    this.audio.onended = () => {
      if (this.activeButton) {
        this.activeButton.classList.remove("active");
        this.activeButton = null;
      }
    };
  }

  disconnect() {
    // Clean up when controller is disconnected
    if (this.audio) {
      this.audio.pause();
      this.audio = null;
    }
    this.activeButton = null;
  }
}
